//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "score-detail",
  data() {
    return {
      scorePlanId: null,
      scorePlanDto: {},
      scoreStatus: [
        {label: '未评分', code: null},
        {label: '未评分', code: 'NOT_STARTED'},
        {label: '评分中', code: 'ONGOING'},
        {label: '已评分', code: 'FINISH'},
        {label: '预期未评分', code: 'NOT_SCORING'},
        {label: '已禁止评分', code: 'DISABLED'},
      ],
      selectModel: 'base'
    }
  },
  methods: {
    backLast() {
      this.$router.go(-1);
    },
    changeShowModel(str) {
      this.selectModel = str;
    },
    changeShow(data) {
      if (data.cellShow) {
        this.$set(data, 'cellShow', false);
        return;
      }
      this.$set(data, 'cellShow', true);
    },
    changeSelected(data, str) {
      this.$set(data, 'showInfoType', str);
    },
    getScorePlanDto() {
      this.$loadingShow();
      this.$get(`api/sourceRating/${this.scorePlanId}`).then((res) => {
        if (res) {
          this.scorePlanDto = res;
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    showRuleList(item) {
      let str = '';
      if (item.length) {
        item.forEach(val => {
          str += val + '<br/>';
        })
      }
      if (!str) {
        str = '暂无数据'
      }
      this.$vux.toast.text(str, 'middle')
    },
    viewScoreFlow() {
      console.log(this.scorePlanDto);
      this.$router.push(`/workflow/${this.scorePlanDto.requestId}`);
    }
  },
  mounted() {
    this.scorePlanId = this.$route.params.id;
    this.getScorePlanDto();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-score/score-detail.vue